import qs from 'qs'

export const queryAboutPage = () => {
  const query = qs.stringify(
    {
      populate: {
        ...queryFragmentSingleTypeDefault,
        ...queryFragmentBlocks,
        cover_image: true
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `about-page?${query}`
}
